
















































import { Vue, Component } from 'vue-property-decorator';
import RegisterCard from '@/components/brand/RegisterCard.vue';
import VueRecaptcha from 'vue-recaptcha';
import { eventBus } from '../../main';
import { REGISTER_ADMIN, SHOW_SNACKBAR } from '../../common/constants';
import { BUDTENDER_PORTAL, LOGIN_PAGE } from '../../common/routes.config';
import errorModule from '../../store/modules/error.module';
import budtenderModule from '../../store/modules/budtender.module';
import { RegisterFeature } from '../../common/types';


@Component({
  components: {
    RegisterCard,
    VueRecaptcha,
  },
})
export default class RegisterBudtender extends Vue {
  isVerified = false;

  password = '';

  full_name: '';

  features: Array<RegisterFeature> = [
    {
      title: 'Brand Assets',
      body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ',
      icon: 'mdi-palette',
    },
    {
      title: 'Video Vault',
      body:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ',
      icon: 'mdi-video',
    },
    {
      title: 'Budtender Hub',
      body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ',
      icon: 'mdi-leaf',
    },
    {
      title: 'Meeting Center',
      body:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      icon: 'mdi-handshake',
    },
  ];

  created(): void {
    // If brandId is not set in params, redirect to login and show error.
    if (!this.$router.currentRoute.params.budtenderId) {
      eventBus.$emit(
        SHOW_SNACKBAR,
        'Invalid registration invite. Please have the admin resend invitation',
      );
      this.$router.push(LOGIN_PAGE);
      return;
    }
    // RegisterAdminCard emits REGISTER_ADMIN when registration was successful
    eventBus.$on(REGISTER_ADMIN, this.registrationCompleted);
  }

  async submitForm(): Promise<void> {
    if (!this.isVerified) {
      return;
    }
    const { budtenderId } = this.$router.currentRoute.params;
    const payload = {
      budtenderId,
      password: this.password,
      full_name: this.full_name,
    };
    await budtenderModule.activateBudtender(payload);
    if (errorModule.hasError) {
      errorModule.clearError();
      return;
    }
    await this.registrationCompleted();
  }

  async onVerify(): Promise<void> {
    this.isVerified = true;
    this.submitForm();
  }

  /**
   * Registeration was successful, send admin to portal.
   */
  async registrationCompleted(): Promise<void> {
    setTimeout(() => {
      this.cueConfetti();
      this.$router.push(BUDTENDER_PORTAL);
    }, 2500);
  }

  cueConfetti(): void {
    const vueInstance = this as any;
    vueInstance.$confetti.start();
    setTimeout(() => {
      vueInstance.$confetti.stop();
    }, 4000);
  }
}
